import { RxDashboard } from "react-icons/rx";
import { BsBoxes } from "react-icons/bs";
import { MdOutlineShoppingBag } from "react-icons/md";
import { LuClock8 } from "react-icons/lu";
import { FaRegChartBar } from "react-icons/fa";

export default [
    {
        id: "MainDashboard",
        title: "Main Dashboard",
        // icon: <RxDashboard size={20} />,
        navLink: "/dashboard",
    },
    {
        id: "FBMDashboard",
        title: "FBM Dashboard",
        // icon: <RxDashboard size={20} />,
        navLink: "/fbm/dashboard",
    },
    {
        id: "Products",
        title: "Products",
        icon: <BsBoxes size={20} />,
        navLink: "/fbm/products",
        children: [
            {
                id: "ManagePlatformProducts",
                title: "Manage Platform Products",
                navLink: "/fbm/products/manageproducts",
            },
            {
                id: "ManageFulfillmentSKU",
                title: "Manage Fulfillment SKU",
                navLink: "/fbm/products/managesku",
            },
        ]
    },
    {
        id: "Orders",
        title: "Orders",
        icon: <MdOutlineShoppingBag size={20} />,
        navLink: "/fbm/orders",
        children: [
            {
                id: "SenttoWarehouse",
                title: "Sent to Warehouse",
                navLink: "/fbm/orders/sent",
                children: [
                    {
                        id: "OrderManagement",
                        title: "Order Management",
                        navLink: "/fbm/orders/sent/management",
                    },
                    {
                        id: "CreateNewShipment",
                        title: "Create New Shipment",
                        navLink: "/fbm/orders/sent/newshipment",
                    },
                    {
                        id: "TrackShipment",
                        title: "Track Shipment",
                        navLink: "/fbm/orders/sent/trackshipment",
                    },
                    {
                        id: "ReceivedInventory",
                        title: "Received Inventory",
                        navLink: "/fbm/orders/sent/receivedinventory",
                    },
                    {
                        id: "InventoryDiscrepancies",
                        title: "Inventory Discrepancies",
                        navLink: "/fbm/orders/sent/inventorydiscrepancies",
                    },
                ]
            },
            {
                id: "BackfromWarehouse",
                title: "Back from Warehouse",
                navLink: "/fbm/orders/back",
                children: [
                    {
                        id: "ReverseOrderManagement",
                        title: "Reverse Order Management",
                        navLink: "/fbm/orders/back/reverseorder",
                    },
                    {
                        id: "CreateReturnShipment",
                        title: "Create Return Shipment",
                        navLink: "/fbm/orders/back/returnshipment",
                    },
                    {
                        id: "TrackShipment",
                        title: "Track Shipment",
                        navLink: "/fbm/orders/back/trackshipment",
                    },
                    {
                        id: "ReceivedInventory",
                        title: "Received Inventory",
                        navLink: "/fbm/orders/back/receivedinventory",
                    },
                    {
                        id: "InventoryDiscrepancies",
                        title: "Inventory Discrepancies",
                        navLink: "/fbm/orders/back/inventorydiscrepancies",
                    },
                ]
            },
        ]
    },
    {
        id: "ScheduleDropoffs",
        title: "Schedule Drop-offs",
        icon: <LuClock8 size={20} />,
        navLink: "/fbm/schedule",
    },
    {
        id: "Reports",
        title: "Reports",
        icon: <FaRegChartBar size={20} />,
        navLink: "/fbm/reports",
        children: [
            {
                id: "SalesReport",
                title: "Sales Report",
                navLink: "/fbm/reports/sales",
            },
            {
                id: "InventoryReport",
                title: "Inventory Report",
                navLink: "/fbm/reports/inventory",
            },
            {
                id: "ExpiryDateReport",
                title: "Expiry Date Report",
                navLink: "/fbm/reports/expirydate",
            },
            {
                id: "InventoryAging",
                title: "Inventory Aging",
                navLink: "/fbm/reports/inventoryaging",
            },
            {
                id: "InventoryReconciliation",
                title: "Inventory Reconciliation",
                navLink: "/fbm/reports/inventoryreconciliation",
            },
            {
                id: "FinancialReport",
                title: "Financial Report",
                navLink: "/fbm/reports/financial",
            },
        ]
    },
];
